// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invisible-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0; }

.filter-container {
  padding: 10px;
  border: 1px dashed #C1C1C1;
  background-color: #F8F8F8;
  margin-bottom: 10px; }
  .filter-container .add-filter-button {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    color: #1565C0;
    padding-top: 7px; }
  .filter-container .filter-panel-body {
    padding: 5px;
    background-color: white;
    display: flex;
    flex-direction: column;
    width: -moz-fit-content;
    width: fit-content; }
  .filter-container .filter-item {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 12px;
    gap: 5px;
    height: 32px;
    background: #FFFFFF;
    border: 1px solid #CCCCCC;
    border-radius: 100px;
    margin-right: 10px;
    margin-bottom: 5px;
    cursor: pointer; }
    .filter-container .filter-item .filter-item-inner {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 140%;
      color: #333333; }
`, "",{"version":3,"sources":["webpack://./src/components/filters/filters.scss"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,QAAQ;EACR,OAAO,EAAA;;AAGT;EACE,aAAa;EACb,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB,EAAA;EAJrB;IAOI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB,EAAA;EAbpB;IAiBI,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,uBAAkB;IAAlB,kBAAkB,EAAA;EArBtB;IAyBI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe,EAAA;IArCnB;MAwCM,qBAAqB;MACrB,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,cAAc,EAAA","sourcesContent":[".invisible-backdrop {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n}\n\n.filter-container {\n  padding: 10px;\n  border: 1px dashed #C1C1C1;\n  background-color: #F8F8F8;\n  margin-bottom: 10px;\n\n  .add-filter-button {\n    font-family: 'Roboto';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 16px;\n    color: #1565C0;\n    padding-top: 7px;\n  }\n\n  .filter-panel-body {\n    padding: 5px;\n    background-color: white;\n    display: flex;\n    flex-direction: column;\n    width: fit-content;\n  }\n\n  .filter-item {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 6px 12px;\n    gap: 5px;\n    height: 32px;\n    background: #FFFFFF;\n    border: 1px solid #CCCCCC;\n    border-radius: 100px;\n    margin-right: 10px;\n    margin-bottom: 5px;\n    cursor: pointer;\n\n    .filter-item-inner {\n      font-family: 'Roboto';\n      font-style: normal;\n      font-weight: 700;\n      font-size: 14px;\n      line-height: 140%;\n      color: #333333;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
